import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './containers/login-page/login-page.component';
import {AnonymousAuthGuardService} from './services/anonymous-auth-guard.service';
import {RequestPasswordResetPageComponent} from './containers/request-password-reset-page/request-password-reset-page.component';
import {PasswordResetPageComponent} from './containers/password-reset-page/password-reset-page.component';
import {RegistrationPageComponent} from './containers/registration-page/registration-page.component';

const routes: Routes = [
    {
        path: 'login',
        component: LoginPageComponent,
        canActivate: [AnonymousAuthGuardService]
    },
    {
        path: 'register',
        component: RegistrationPageComponent,
        canActivate: [AnonymousAuthGuardService]
    },
    {
        path: 'password-reset',
        component: RequestPasswordResetPageComponent,
        canActivate: [AnonymousAuthGuardService],
    },
    {
        path: 'reset',
        component: PasswordResetPageComponent,
        canActivate: [AnonymousAuthGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserRoutingModule {
}
